export default __webpack_public_path__ + "static/media/access-denied.26acf5f4.svg";